import React, { useState } from "react";
import PropTypes from "prop-types";
import { FiArrowRight, FiCheckCircle, FiClock, FiEye, FiLock, FiX } from "react-icons/fi";
import { useAuth } from "context/auth-context";
import { useTranslation } from "react-i18next";

export const QualificationPopUp = ({ ShowPopup, attemptFunction, setSelectedSurveyData }) => {
  const { t } = useTranslation();
  const [buttonClicked, setButtonClicked] = useState(false);
  const { auth } = useAuth();
  const panelistId = auth.panelistId;

  const handleAttempt = () => {
    if (!buttonClicked) {
      setButtonClicked(true);
      const payload = {
        affilate: null,
        apiClientId: setSelectedSurveyData.apiClientId,
        isGuestUser: null,
        panelListId: panelistId,
        points: setSelectedSurveyData.finalPoint || setSelectedSurveyData.points,
        sid: setSelectedSurveyData.s_id,
        source: null,
        studyName: setSelectedSurveyData.studyName,
        study_id: setSelectedSurveyData._id,
        v_id: null,
        vid: null,
        vendorCpi: setSelectedSurveyData.vendorCpi,
        loi: setSelectedSurveyData.loi,
        projectCpi: setSelectedSurveyData.fees,
      };
      attemptFunction(payload);
    }
  };

  const tips = [
    { icon: FiEye, title: t("joinnow.bonus.attentive"), text: [t("joinnow.bonus.carefully"), t("joinnow.bonus.quickly")] },
    { icon: FiCheckCircle, title: t("joinnow.bonus.Be"), text: [t("joinnow.bonus.accurate"), t("joinnow.bonus.information")] },
    { icon: FiClock, title: t("joinnow.bonus.patient"), text: [t("joinnow.bonus.won"), t("joinnow.bonus.surveys")] },
  ];

  return (
    <div>
      <div className="zs-backdrop" role="dialog" aria-modal="true" aria-labelledby="qualification-title" onClick={ShowPopup}>
        <div className="zs-modal max-w-[480px]">
          <button type="button" className="zs-icon-btn zs-modal-close" aria-label="Close" onClick={ShowPopup}>
            <FiX />
          </button>

          <div className="px-5 pt-5 pb-4 pr-14 sm:px-6 sm:pt-6">
            <span className="zs-eyebrow">{t("joinnow.bonus.Qualification")}</span>
            <h2 id="qualification-title" className="text-lg font-semibold font-display text-ink">
              {t("joinnow.bonus.opinion")}
            </h2>
            <p className="flex items-center gap-1.5 mt-1 text-sm text-ink-3">
              <FiLock className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
              {t("joinnow.bonus.completely")}
            </p>
          </div>

          <ul className="flex flex-col gap-2 px-5 sm:px-6">
            {tips.map(({ icon: Icon, title, text }, index) => (
              <li key={index} className="flex gap-3 p-3 border rounded-lg border-line bg-surface-2">
                <span className="inline-flex items-center justify-center rounded w-9 h-9 shrink-0 bg-primary-soft text-primary-text">
                  <Icon className="w-4 h-4" aria-hidden="true" />
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-ink">{title}</p>
                  <p className="mt-0.5 text-[13px] leading-relaxed text-ink-3">
                    <span>{text[0]}</span>
                    <span> {text[1]}</span>
                  </p>
                </div>
              </li>
            ))}
          </ul>

          <div className="px-5 pt-5 pb-5 sm:px-6 sm:pb-6">
            <button
              className="zs-btn zs-btn-primary zs-btn-lg zs-btn-block"
              disabled={buttonClicked}
              onClick={handleAttempt}
            >
              {t("joinnow.bonus.Start")}
              <FiArrowRight aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
QualificationPopUp.propTypes = {
  setSelectedSurveyData: PropTypes.object.isRequired,
  attemptFunction: PropTypes.func.isRequired,
  ShowPopup: PropTypes.func.isRequired,
};
